import { useTranslation } from 'react-i18next';
import useStudioGroup from '../../../hooks/useStudioGroup';

const infoLinks: Record<string, string> = {
  ES: 'https://info.pelckmansportail.be',
  SO: 'https://info.pelckmansportaal.be',
};

export default function Platforms() {
  const { t } = useTranslation();
  const studioGroup = useStudioGroup();
  return (
    <>
      <p className="list-sections__paragraph">{t('PAGES.HELP.SECTIONS.PLATFORMS.P1')}</p>
      <p className="list-sections__paragraph">{t('PAGES.HELP.SECTIONS.PLATFORMS.P2')}</p>
      {(studioGroup === 'SO' || studioGroup === 'ES') && (
        <p
          className="list-sections__paragraph list-sections__paragraph__link"
          dangerouslySetInnerHTML={{
            __html: t('PAGES.HELP.SECTIONS.PLATFORMS.P3', { url: infoLinks[studioGroup] }),
          }}
        />
      )}
    </>
  );
}
